import Txp from './Txp';
import OwaTxpStyle from '../store/viewSchema/OwaTxpStyle';
import TxpSource from '../store/viewSchema/TxpSource';
import populateCardViewedDatapoint from '../utils/telemetry/populateCardViewedDatapoint';
import createCalendarPeekTxpConfiguration from '../utils/view/createCalendarPeekTxpConfiguration';
import createTxpStrings from '../utils/view/createTxpStrings';
import { createCalendarPeekStyle } from '../utils/view/createTxpStyle';
import getInternetMessageIdFromTxpObject from '../utils/view/getInternetMessageIdFromTxpObject';
import getOriginFromTxpObject from '../utils/view/getOriginFromTxpObject';
import getTxpLocation from '../utils/view/getTxpLocation';
import { observer } from 'mobx-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { logTxpDatapoint } from 'owa-txp/lib/utils/TxpUtils';
import * as React from 'react';
import { TxpObject } from 'txp-data';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import TxpDatapoint from 'txp-data/lib/schema/configSchema/TxpDatapoint';

let styles = require('./Txp.scss');

export interface TxpPeekWrapperProps extends React.HTMLProps<HTMLDivElement> {
    entityNamesMap: number;
    txpObject: TxpObject;
    colorScheme?: ColorScheme;
    txpLocation: EnhancedLocation;
    source: TxpSource;

    // Callback to show the mail Popout from calendar
    onViewInMailClicked?: () => void;
    isInvoiceSupported?: boolean;
    isServiceReservationSupported?: boolean;
}

@observer
export default class TxpPeekWrapper extends React.Component<TxpPeekWrapperProps> {
    private txpConfiguration: TxpConfiguration;
    private txpStyle: OwaTxpStyle;

    constructor(props: TxpPeekWrapperProps) {
        super(props);
        let {
            entityNamesMap,
            isInvoiceSupported,
            isServiceReservationSupported,
            txpLocation,
            onViewInMailClicked,
        } = this.props;

        this.txpConfiguration = createCalendarPeekTxpConfiguration(
            isInvoiceSupported,
            entityNamesMap,
            txpLocation,
            this.props.colorScheme,
            styles,
            isServiceReservationSupported,
            this.datapointLogger,
            onViewInMailClicked
        );

        this.onCardViewed();
    }

    public UNSAFE_componentWillReceiveProps(newProps: TxpPeekWrapperProps) {
        if (newProps.txpLocation != this.props.txpLocation) {
            let { txpImages } = this.txpConfiguration;

            this.txpConfiguration.getLocationControl = (
                showFullAddress: boolean,
                telephone: string
            ) =>
                getTxpLocation(
                    newProps.txpLocation,
                    showFullAddress,
                    txpImages,
                    this.txpStyle,
                    telephone
                );
        }
    }

    render() {
        let { colorScheme, txpObject } = this.props;

        this.txpStyle = createCalendarPeekStyle(colorScheme, styles);

        let txpStrings = createTxpStrings();

        if (txpObject) {
            return (
                <Txp
                    txpObject={txpObject}
                    txpStyle={this.txpStyle}
                    txpStrings={txpStrings}
                    txpConfiguration={this.txpConfiguration}
                    className={styles.peekTxp}
                />
            );
        } else {
            return <Spinner className={styles.spinner} size={SpinnerSize.large} />;
        }
    }

    private onCardViewed = () => {
        const { entityNamesMap, txpObject } = this.props;
        const internetMessageId = getInternetMessageIdFromTxpObject(txpObject);

        populateCardViewedDatapoint(
            this.datapointLogger,
            getOriginFromTxpObject(txpObject),
            entityNamesMap,
            internetMessageId
        );
    };

    private datapointLogger = (datapoint: TxpDatapoint, datapointName: string) => {
        logTxpDatapoint(
            datapoint,
            datapointName,
            this.props.source,
            getInternetMessageIdFromTxpObject(this.props.txpObject)
        );
    };
}
